import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleCardComponent } from './article-card/article-card.component';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { SlugifyService } from '../core/services/slugify.service';
import { ArticleCardLargeComponent } from './article-card-large/article-card-large.component';
import { TrendingCardComponent } from './trending-card/trending-card.component';
import { ArticleHorizontalCardComponent } from './article-horizontal-card/article-horizontal-card.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MostViewedWriterCardComponent } from './most-read-writer-card/most-read-writer-card.component';
import { ContentCardComponent } from './content-card/content-card.component';

@NgModule({
  declarations: [
    ArticleCardComponent,
    ArticleCardLargeComponent,
    TrendingCardComponent,
    ArticleHorizontalCardComponent,
    MostViewedWriterCardComponent,
    ContentCardComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    ButtonModule,
    LazyLoadImageModule
  ],
  exports: [
    ArticleCardComponent,
    ArticleCardLargeComponent,
    TrendingCardComponent,
    ArticleHorizontalCardComponent,
    MostViewedWriterCardComponent,
    ContentCardComponent
  ],
  providers: [SlugifyService]
})
export class LayoutModule {}
